import { axios } from "@Root/API";

export const postRecoveryEmail = email => {
  return axios.post("password/reset", { email });
};
